<div class="ms-overlay" *ngIf="(state$ | async) as s">
  <div class="ms-card">
    <div class="ms-check">✓</div>

    <div class="ms-top">YOU ARE NOW USING</div>

    <div class="ms-name">
      {{ s.name }}
      <span *ngIf="s.premium" class="ms-chip">PREMIUM</span>
    </div>

    <div class="ms-sub">
      Active model switched successfully
    </div>
  </div>
</div>
